var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "166px",
    height: "49px",
    viewBox: "0 0 166 49",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "logo") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "logo",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Logo_2_",
    transform: "translate(0.000000, 0.508000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_93_2_",
    transform: "translate(28.528000, 17.802000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_748_2_",
    points: "0.8897 0.6744 16.0785 0.6744 16.0785 3.8636 10.8558 3.8636 10.8558 14.9065 6.1115 14.9065 6.1115 3.8636 0.8896 3.8636 0.8896 0.6744"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_94_2_",
    transform: "translate(45.145000, 17.802000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_749_2_",
    points: "12.8157 8.9469 5.6207 8.9469 5.6207 14.9065 0.8764 14.9065 0.8764 0.6744 5.6207 0.6744 5.6207 5.7577 12.8157 5.7577 12.8157 0.6744 17.56 0.6744 17.56 14.9065 12.8157 14.9065"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(64.000000, 16.000000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_96_2_",
    transform: "translate(0.000000, 0.492000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_95_2_",
    transform: "translate(0.509000, 0.766000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.5973,0.7803 C14.6194,0.7803 18.8652,2.4345 18.8652,8.3352 C18.8652,14.2359 14.6194,15.8885 9.5973,15.8885 C4.5752,15.8885 0.3286,14.2351 0.3286,8.3352 C0.3286,2.4353 4.5743,0.7803 9.5973,0.7803 M9.5973,12.6994 C12.1511,12.6994 13.8423,11.3239 13.8423,8.3352 C13.8423,5.3651 12.1511,3.9694 9.5973,3.9694 C7.0653,3.9694 5.3515,5.3651 5.3515,8.3352 C5.3515,11.3239 7.0653,12.6994 9.5973,12.6994",
    id: "Path_750_2_"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_97_2_",
    transform: "translate(85.174000, 17.802000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_752_2_",
    points: "0.3328 0.6744 7.2692 0.6744 10.518 10.0623 10.5583 10.0623 13.8103 0.6744 20.7467 0.6744 20.7467 14.9065 16.2786 14.9065 16.2786 4.2622 16.2383 4.2622 12.4935 14.9065 8.5852 14.9065 4.8371 4.2622 4.7968 4.2622 4.7968 14.9065 0.3328 14.9065"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_98_2_",
    transform: "translate(108.085000, 17.802000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_753_2_",
    points: "0.7051 0.6744 7.6415 0.6744 10.8903 10.0623 10.9306 10.0623 14.1794 0.6744 21.1158 0.6744 21.1158 14.9065 16.651 14.9065 16.651 4.2622 16.6115 4.2622 12.8658 14.9065 8.9575 14.9065 5.2094 4.2622 5.1699 4.2622 5.1699 14.9065 0.7051 14.9065 0.7051 0.6744"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_99_2_",
    transform: "translate(131.993000, 17.802000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_754_2_",
    points: "0.078 0.6744 14.3326 0.6744 14.3326 3.7436 4.8223 3.7436 4.8223 6.3118 13.731 6.3118 13.731 9.2626 4.8223 9.2626 4.8223 11.8341 14.3326 11.8341 14.3326 14.9033 0.078 14.9033"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_100_2_",
    transform: "translate(148.164000, 17.803000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_755_2_",
    points: "12.2512 0.6742 12.2512 9.5845 12.2109 9.5845 5.6143 0.6742 0.1516 0.6742 0.1516 14.9063 4.7364 14.9063 4.7364 5.9178 4.7767 5.9178 11.5948 14.9063 16.836 14.9063 16.836 0.6742"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_101_2_",
    transform: "translate(29.258000, 36.730000)",
    fill: "#868787"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path_756_2_",
    points: "9.9422 0.2114 7.1952 6.8821 4.4449 0.2114 0.7476 0.2114 0.7476 9.4729 3.187 9.4729 3.187 2.0549 3.2128 2.0549 6.1443 9.4762 8.2463 9.4762 11.1778 2.0549 11.2036 2.0549 11.2036 9.4729 13.647 9.4729 13.647 0.2114"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(43.000000, 36.000000)",
    fill: "#868787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_104_2_",
    transform: "translate(0.000000, 0.492000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_102_2_",
    transform: "translate(0.849000, 1.785000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.249,5.8537 C8.5878,7.5014 7.0045,8.1892 4.9162,8.1892 C2.1659,8.1892 0.3257,7.073 0.3257,4.4524 C0.3257,1.8318 2.1683,0.7148 4.9162,0.7148 C7.9266,0.7148 9.3794,2.2329 9.3794,4.8543 L9.3794,5.0621 L2.6838,5.0621 L2.6838,5.0895 C2.6838,5.7507 3.3587,6.7622 4.9162,6.7622 C5.6694,6.8466 6.4047,6.494 6.8104,5.8538 L9.249,5.8538 L9.249,5.8537 Z M7.0174,3.7131 L7.0174,3.6873 C7.0174,3.3112 6.5342,2.1435 4.8639,2.1435 C3.8502,2.0284 2.9118,2.6929 2.6838,3.6873 L2.6838,3.7131 L7.0174,3.7131 Z",
    id: "Path_757_2_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_103_2_",
    transform: "translate(10.141000, 0.043000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.5853,8.8029 L7.5595,8.8029 C6.8728,9.5927 5.8527,10.0109 4.8092,9.9304 C2.642,9.9304 0.9307,8.6982 0.9307,6.2725 C0.8871,4.2501 2.4913,2.5753 4.5137,2.5317 C4.6123,2.5296 4.7109,2.5314 4.8093,2.5373 C5.8138,2.4422 6.8044,2.8263 7.4822,3.5738 L7.508,3.5738 L7.508,0.2493 L9.7903,0.2493 L9.7903,9.6718 L7.5853,9.6718 L7.5853,8.8029 L7.5853,8.8029 Z M5.4455,8.244 C6.5318,8.3359 7.4869,7.5298 7.5788,6.4435 C7.5847,6.3738 7.5869,6.3038 7.5854,6.2339 C7.611,5.144 6.7483,4.2397 5.6585,4.214 C5.5872,4.2123 5.5158,4.2145 5.4447,4.2205 C4.3571,4.1228 3.3963,4.9253 3.2986,6.0128 C3.292,6.0863 3.2895,6.1601 3.2912,6.2338 C3.2668,7.3255 4.132,8.2302 5.2237,8.2546 C5.2975,8.2562 5.3713,8.2538 5.4447,8.2472",
    id: "Path_758_2_"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M64.4888,38.395 L66.7711,38.395 L66.7711,36.7843 L64.4888,36.7843 L64.4888,38.395 Z M64.4888,36.7843 L64.4888,46.2068 L66.7711,46.2068 L66.7711,39.2518 L64.4888,39.2518 L64.4888,36.7843 Z",
    id: "Path_760_2_",
    fill: "#868787"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(67.000000, 37.000000)",
    fill: "#868787"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_107_2_",
    transform: "translate(0.000000, 0.492000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_105_2_",
    transform: "translate(0.442000, 0.785000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.05,3.5456 C6.8116,2.7228 6.0027,2.202 5.155,2.3255 C4.069,2.1849 3.0747,2.9512 2.934,4.0372 C2.9161,4.1751 2.9128,4.3146 2.9242,4.4532 C2.8351,5.5446 3.6476,6.5016 4.739,6.5908 C4.8776,6.6021 5.0171,6.5988 5.155,6.581 C6.0589,6.6774 6.8847,6.0615 7.05,5.1676 L9.4105,5.1676 C8.995,7.6311 7.2312,8.19 4.961,8.19 C2.3404,8.19 0.563,7.0738 0.563,4.4532 C0.563,1.8326 2.4056,0.7156 5.1535,0.7156 C6.9188,0.7156 8.9821,1.2487 9.4098,3.5456 L7.05,3.5456 Z",
    id: "Path_761_2_"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_106_2_",
    transform: "translate(10.266000, 0.786000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.7027,3.1033 C0.9741,0.9619 2.9464,0.7155 4.8148,0.7155 C8.0837,0.7155 8.7843,1.7802 8.7843,3.0776 L8.7843,6.5277 C8.7698,7.008 8.8582,7.4858 9.0436,7.929 L6.7613,7.929 C6.6781,7.6904 6.6253,7.4423 6.6043,7.1905 C5.6737,7.9028 4.5182,8.2572 3.3483,8.1891 C1.5331,8.1891 0.2614,7.5537 0.2614,5.9341 C0.2614,4.2485 1.7537,3.8845 3.1413,3.7935 L5.567,3.626 C6.2677,3.5737 6.502,3.4569 6.502,2.9012 C6.502,2.3455 6.0341,2.0653 4.7109,2.0653 C3.738,2.0653 3.2323,2.1458 2.9077,3.1026 L0.7027,3.1033 Z M6.5817,4.5424 C6.1544,4.7244 5.697,4.8257 5.2327,4.8412 L3.9095,4.958 C3.1042,5.0232 2.7015,5.2431 2.7015,5.8672 C2.7015,6.4913 3.2846,6.8401 4.1407,6.8401 C5.2956,6.8401 6.5801,6.2812 6.5801,5.1142 L6.5817,4.5424 Z",
    id: "Path_762_2_"
  })))), /*#__PURE__*/React.createElement("polygon", {
    id: "Path_764_2_",
    fill: "#868787",
    points: "87.5547 46.2069 89.837 46.2069 89.837 36.7844 87.5547 36.7844"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_108_2_",
    fill: "#0156A1",
    transform: "translate(0.000000, 0.492000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,15.7713 C0,15.7713 48.2587,-14.5169 129.1605,8.8985 L129.1605,13.2095 C129.1605,13.2095 59.5762,-12.9852 0,16.1756 L0,15.7713 Z",
    id: "Path_765_2_"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(95.000000, 39.000000)",
    fill: "#0156A1"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "0.2099 0.4557 0.7387 0.4557 2.8944 7.0658 2.9151 7.0658 5.2439 0.4557 5.8335 0.4557 8.1623 7.0658 8.1826 7.0658 10.3387 0.4557 10.8675 0.4557 8.4775 7.7167 7.8879 7.7167 5.5489 1.1066 5.5286 1.1066 3.1896 7.7167 2.5996 7.7167"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "13.9695 0.4557 19.705 0.4557 19.705 0.8624 14.4371 0.8624 14.4371 3.7508 19.4913 3.7508 19.4913 4.1575 14.4371 4.1575 14.4371 7.3099 19.7658 7.3099 19.7658 7.7166 13.9695 7.7166"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.2037,0.4557 L27.1189,0.4557 C28.5118,0.4557 29.234,1.1065 29.234,2.2456 C29.234,2.9573 28.9088,3.6795 27.8103,3.9134 L27.8103,3.9337 C29.2239,4.076 29.4781,5.1032 29.4781,5.7236 C29.4781,6.5066 29.0511,7.7167 27.0475,7.7167 L23.2037,7.7167 L23.2037,0.4557 Z M23.6712,3.7508 L26.9051,3.7508 C27.2814,3.7508 28.766,3.7508 28.766,2.276 C28.766,0.8624 27.607,0.8624 26.8341,0.8624 L23.6712,0.8624 L23.6712,3.7508 L23.6712,3.7508 Z M23.6712,7.3099 L26.9457,7.3099 C27.3119,7.3099 29.0101,7.3099 29.0101,5.6826 C29.0101,4.1575 27.6273,4.1575 26.824,4.1575 L23.6712,4.1575 L23.6712,7.3099 L23.6712,7.3099 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3324,5.3168 C33.3425,6.6692 34.1661,7.4725 36.1187,7.4725 C37.8985,7.4725 38.5493,6.7097 38.5493,5.8557 C38.5493,5.0419 38.1629,4.6761 36.6373,4.3606 L35.2849,4.0759 C33.6986,3.7402 33.0883,3.2726 33.0883,2.1741 C33.0883,1.0861 34.0339,0.2929 35.834,0.2929 C37.6645,0.2929 38.8238,0.964 38.8745,2.5098 L38.4069,2.5098 C38.3457,1.6761 37.8781,0.6996 35.9662,0.6996 C34.1966,0.6996 33.6171,1.3504 33.6171,2.1842 C33.6171,2.9571 33.9528,3.3435 35.3356,3.6184 L36.8307,3.9132 C38.2848,4.1979 39.078,4.6658 39.078,5.8248 C39.078,6.8114 38.4272,7.8791 36.1596,7.8791 C33.7797,7.8791 32.8645,6.852 32.8645,5.3167 L33.3324,5.3167 L33.3324,5.3168 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    points: "42.6172 0.4557 43.0848 0.4557 43.0848 3.6896 48.6475 3.6896 48.6475 0.4557 49.1154 0.4557 49.1154 7.7167 48.6475 7.7167 48.6475 4.0964 43.0848 4.0964 43.0848 7.7167 42.6172 7.7167"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.5191,0.2931 C59.4683,0.2931 60.373,2.6625 60.373,4.0862 C60.373,5.5099 59.4683,7.8793 56.5191,7.8793 C53.5699,7.8793 52.6648,5.5099 52.6648,4.0862 C52.6648,2.6625 53.5699,0.2931 56.5191,0.2931 Z M56.5191,7.4725 C58.7056,7.4725 59.9055,5.8249 59.9055,4.0861 C59.9055,2.3473 58.7056,0.6997 56.5191,0.6997 C54.3326,0.6997 53.1327,2.3473 53.1327,4.0861 C53.1327,5.8249 54.3327,7.4725 56.5191,7.4725 Z",
    id: "Shape"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.9228,0.4557 L67.7058,0.4557 C68.7228,0.4557 69.9126,0.8117 69.9126,2.4694 C69.9126,3.6896 69.2208,4.5233 67.6345,4.5233 L64.3905,4.5233 L64.3905,7.7166 L63.9229,7.7166 L63.9229,0.4557 L63.9228,0.4557 Z M64.3904,4.1166 L67.6243,4.1166 C68.5091,4.1166 69.4446,3.7711 69.4446,2.4897 C69.4446,0.8624 68.1429,0.8624 67.5124,0.8624 L64.3904,0.8624 L64.3904,4.1166 Z",
    id: "Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.919a9f48214ac959f350fb62f741f5c8.svg";
export { ForwardRef as ReactComponent };